import * as R from 'ramda';
import Moment from 'moment';
import { libs } from '@fasstech/spid-front';

const formatStartDate = (date) => R.isNil(date) || R.isEmpty(date) ? '' : Moment(date).format('DD/MM/YYYY');
const formatDate = (date) => R.isNil(date) || R.isEmpty(date) ? '' : Moment(date).format('DD/MM/YYYY HH:mm:ss');
const getCollegesInformations = (proposition) => {
  const selectedColleges = R.compose(
    R.uniq,
    R.keys,
    R.mergeAll,
    R.map(R.filter(R.propEq('isSelected', true))),
    R.reject(R.isNil),
    R.paths([['staff'], ['health', 'staff']])
  )(proposition);

  const selectedCollegesString = R.compose(
    R.join(', '),
    R.map(college => libs.collegeLabel(college, proposition.ccn, 'PREVOYANCE'))
  )(selectedColleges);

  return {
    string: selectedCollegesString,
    C_isSelected: R.includes('C', selectedColleges),
    NC_isSelected: R.includes('NC', selectedColleges),
    APP_isSelected: R.includes('APP', selectedColleges),
    AM_isSelected: R.includes('AM', selectedColleges),
    TOUS_isSelected: R.includes('TOUS', selectedColleges)
  };
};
const getStatus = (status) => {
  const s = [];
  s['unhold'] = 'En attente';
  s['active'] = 'Actif';
  s['sentToManagementSystem'] = 'Envoyé au système de mise en gestion';
  s['sentForSignature'] = 'Envoyé en signature';
  s['sentForSignatureDelayed'] = 'Signature DEM TEL 24h';
  s['confirmed'] = 'Signé';
  s['ready'] = 'Prêt';
  s['closed'] = 'Fermé';
  s['duplicate'] = 'Duplicata généré';
  s['confirmedInManagementSystem'] = 'Mise en gestion confirmée';
  s['confirmedInManagementSystemReopened'] = 'Mise en gestion confirmée';
  s['rejectedByManagementSystem'] = 'Rejeté par le système de mise en gestion';
  return !R.isNil(s[status]) ? s[status] : status;
};
const yesNo = (value) => value ? 'OUI' : 'NON';
const getRole = role => role === 'groupe_adhesion' ? 'Groupe adhésion' : (role === 'reseau_commercial' ? 'Réseau commercial' : '');

export {
  formatDate,
  formatStartDate,
  getCollegesInformations,
  yesNo,
  getRole,
  getStatus
};
